export const determineCurrentLanguageFromUrl = (currentUrl:string) => {
  return (currentUrl.includes('es.') || currentUrl.includes('language=spanish') || currentUrl.includes('lang=es')) ? 'es' : 'en'
}

export const getLanguageToggleHostname = (lang: string, url: URL, isProduction: boolean): string => {
  // For non-prod environment, we just add and remove the es subdomain
  // For production we swap the es and www subdomains instead.
  // This can probably be cleaned up somehow.
  const subdomains = url.host.split('.')
  const urlIsSpanish = subdomains[0] === 'es'
  if (lang === 'es') {
    // Return english url
    if (urlIsSpanish) {
      const splicedUrl = subdomains.splice(1).join('.')
      if (isProduction) {
        return `www.${splicedUrl}`
      } else {
        return splicedUrl
      }
    } else {
      return url.host
    }
  } else {
    // Return spanish url
    if (isProduction) {
      // Cut off the 'www' part of the url
      const splicedUrl = subdomains.splice(1).join('.')
      return `es.${splicedUrl}`
    } else {
      return `es.${url.host}`
    }
  }
}

export const getLanguageToggleUrl = (currentLang: string, currentUrl: string, isProduction: boolean): string => {
  const url = new URL(currentUrl)
  const hostname = getLanguageToggleHostname(currentLang, url, isProduction)
  return `${url.protocol}//${hostname}${url.pathname}${url.search}`
}
